export { default as Behance } from './Behance';
export { default as Dribbble } from './Dribbble';
export { default as Instagram } from './Instagram';
export { default as LinkedIn } from './LinkedIn';
export { default as Mail } from './Mail';
export { default as Medium } from './Medium';
export { default as Youtube } from './Youtube';
